import { useState } from "react";
import { toast } from "react-toastify";
import { Authorization } from "../../../Context/Authorization";

const inputStyle = {
  width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0",
  borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff",
  outline: "none", transition: "border-color 0.2s",
};
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "block" };
const errorStyle = { fontSize: 11, color: "#C62828", marginTop: 4 };

const Field = ({ label, error, children }) => (
  <div style={{ marginBottom: 16 }}>
    <label style={labelStyle}>{label}</label>
    {children}
    {error && <div style={errorStyle}>{error}</div>}
  </div>
);

const JfmcTypes = ({ onClose, onAddJfmcType }) => {
  const [jfmcTypeName, setJfmcTypeName] = useState("");
  const [description, setDescription]   = useState("");
  const [errors, setErrors]             = useState({});
  const [submitting, setSubmitting]     = useState(false);
  const Api = process.env.REACT_APP_API;

  const validateForm = () => {
    const newErrors = {};
    if (!jfmcTypeName.trim()) newErrors.jfmcTypeName = "JFMC Type Name is required";
    if (!description.trim())  newErrors.description  = "Description is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) { toast.error("Please fix the errors in the form"); return; }
    setSubmitting(true);
    try {
      const config = Authorization();
      const response = await fetch(`${Api}/api/jfmc-Types`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...config.headers },
        body: JSON.stringify({ jfmcTypeName, description }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Failed to add JFMC Type");
      toast.success("JFMC Type added successfully");
      onAddJfmcType(result);
      onClose();
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(error.message || "Error submitting form");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    /* ── Backdrop ── */
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      {/* ── Modal card ── */}
      <div style={{ background: "#fff", borderRadius: 14, width: 480, maxWidth: "90vw", boxShadow: "0 20px 60px rgba(0,0,0,0.2)", overflow: "hidden" }}>

        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 36, height: 36, background: "rgba(255,255,255,0.15)", borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 18 }}>
            <i className="mdi mdi-tag-plus-outline" />
          </span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>Add JFMC Type</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)" }}>Fill in the details below</div>
          </div>
          <button
            onClick={onClose}
            style={{ background: "rgba(255,255,255,0.15)", border: "none", borderRadius: 7, width: 32, height: 32, color: "#fff", cursor: "pointer", fontSize: 18, display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <i className="mdi mdi-close" />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} style={{ padding: 24 }}>
          <Field label={<>JFMC Type Name <span style={{ color: "#E53E3E" }}>*</span></>} error={errors.jfmcTypeName}>
            <input
              type="text"
              value={jfmcTypeName}
              onChange={(e) => { setJfmcTypeName(e.target.value); if (errors.jfmcTypeName) setErrors((p) => ({ ...p, jfmcTypeName: "" })); }}
              placeholder="Enter JFMC Type Name"
              style={{ ...inputStyle, borderColor: errors.jfmcTypeName ? "#E53E3E" : "#E2E8F0" }}
              onFocus={(e) => e.target.style.borderColor = "#4CAF50"}
              onBlur={(e) => e.target.style.borderColor = errors.jfmcTypeName ? "#E53E3E" : "#E2E8F0"}
            />
          </Field>
          <Field label={<>Description <span style={{ color: "#E53E3E" }}>*</span></>} error={errors.description}>
            <input
              type="text"
              value={description}
              onChange={(e) => { setDescription(e.target.value); if (errors.description) setErrors((p) => ({ ...p, description: "" })); }}
              placeholder="Enter description"
              style={{ ...inputStyle, borderColor: errors.description ? "#E53E3E" : "#E2E8F0" }}
              onFocus={(e) => e.target.style.borderColor = "#4CAF50"}
              onBlur={(e) => e.target.style.borderColor = errors.description ? "#E53E3E" : "#E2E8F0"}
            />
          </Field>

          {/* Actions */}
          <div style={{ display: "flex", gap: 10, paddingTop: 8, borderTop: "1px solid #EDF2F7", marginTop: 8 }}>
            <button
              type="submit"
              disabled={submitting}
              style={{
                display: "flex", alignItems: "center", gap: 8,
                padding: "10px 24px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)",
                color: "#fff", border: "none", borderRadius: 9, fontSize: 14, fontWeight: 700,
                cursor: submitting ? "not-allowed" : "pointer", opacity: submitting ? 0.7 : 1,
                boxShadow: "0 3px 10px rgba(46,125,50,0.3)",
              }}
            >
              <i className={`mdi ${submitting ? "mdi-loading mdi-spin" : "mdi-check-circle-outline"}`} />
              {submitting ? "Saving…" : "Add Type"}
            </button>
            <button
              type="button"
              onClick={onClose}
              style={{ padding: "10px 20px", background: "#fff", color: "#4A5568", border: "1.5px solid #E2E8F0", borderRadius: 9, fontSize: 13, fontWeight: 600, cursor: "pointer" }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JfmcTypes;
